(function () {
  var faq_slider_v1 = new Swiper(".js_faq_items_slider_v1", {
    spaceBetween: 35,
    slidesPerView: 'auto',

    // Responsive breakpoints
    on: {
      resize: function () {
        // if (window.innerWidth > 640) {
        //   faq_slider_v1.destroy();
        // } else {
        //   faq_slider_v1.update();
        // }
      }
    }
  });
})();
